import { render } from "./AddTripSchedule.vue?vue&type=template&id=98c7bfac"
import script from "./AddTripSchedule.vue?vue&type=script&lang=js"
export * from "./AddTripSchedule.vue?vue&type=script&lang=js"
script.render = render

export default script